import { render } from "./demandModel.vue?vue&type=template&id=87367a4a"
import script from "./demandModel.vue?vue&type=script&lang=js"
export * from "./demandModel.vue?vue&type=script&lang=js"

import "./demandModel.vue?vue&type=style&index=0&id=87367a4a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__